import React from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { ContentHeader, ContentBody } from 'areas/shared/components'
import { Form } from 'fw/forms'
import { Box, Label } from 'fw/components'
import { UserAuto } from 'areas/shared/controls'
import * as App from 'modules/app/App'

class Impersonation extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			form: {}
		};
	}

	onChange = (form, callback) => {
		this.setState({ form }, callback);
	}

	onCancel = () => {
		this.props.history.push('/');
	}

	onSubmit = () => {
		App.impersonate(this.state.form.userId);
	}

	render() {
		const context = App.context();

		return (
			<React.Fragment>
				<ContentHeader title='Impersonation'>
				</ContentHeader>
				<ContentBody>
					<Box>
						<Form
							onChange={this.onChange}
							values={this.state.form}
							onSubmit={this.onSubmit}>
							<Row>
								<Col md={12}>
									By selecting a different user, you will be assuming the role of such account and/or user (including permissions, data, links, etc.). However, your actions will be still audited under your profile. <br /><br />
									<Label htmlFor="userId" required>Select the user you would like to impersonate:</Label>
								</Col>
							</Row>
							<Row>
								<Col md={4}>
									<UserAuto name="userId" label="fullName" required showUserTypeCode={false} roles="Administrator" filter={context.login} /> 
								</Col>
								<Col md={6}>
								</Col>
							</Row>
							<hr style={{ marginTop: "10px" }} />
							<div className="pull-right">
								<Button id="btnCancel" bsStyle="link" onClick={this.onCancel}>Cancel</Button>
								<Button id="btnConfirm" type="submit" bsStyle="primary">Impersonate</Button>
							</div>
						</Form>
					</Box>
				</ContentBody>
			</React.Fragment>
		)
	}
}

export default Impersonation;



// WEBPACK FOOTER //
// ./src/areas/main/impersonation/Impersonation.js